import React from 'react';
import { Result, Button } from 'antd';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';

const ForbiddenPage = ({ history, withButton }) => {
  const onHome = () => history.push('/events');

  const showExtra = withButton ? (
    <Button type="primary" onClick={onHome}>
      Back Home
    </Button>
  ) : null;

  return (
    <Result
      status="403"
      title="403"
      subTitle="Sorry, you don't have permission for this page."
      extra={showExtra}
    />
  );
};

ForbiddenPage.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func.isRequired,
  }).isRequired,
  withButton: PropTypes.bool,
};

ForbiddenPage.defaultProps = {
  withButton: true,
};

export default withRouter(ForbiddenPage);
